module.exports = __webpack_public_path__ + "48a7bcb01e293a444306e6cbfb6c74de.png";